export const DemoMahaGencoDataJson ={
    "months":["20-12-2023", "21-12-2023","22-12-2023","23-12-2023","24-12-2023","25-12-2023","26-12-2023","27-12-2023","28-12-2023","29-12-2023","30-12-2023","31-12-2023"],
    "data":[
        {
            "generator":"Generator 1",
            "unit":"MW",
            "actual":[
                100, 200, 300, 400, 500, 600, 700, 800, 900, 1000
            ],
            "nomative":[
                1000, 2000, 3000, 4000, 5000, 6000, 7000,8000, 9000, 10000
            ]
        },
        {
            "generator":"Generator 2",
            "unit":"MW",
            "actual":[
                100, 200, 300, 400, 500, 600, 700, 800, 900, 1000
            ],
            "nomative":[
                1000, 2000, 3000, 4000, 5000, 6000, 7000,8000, 9000, 10000
            ]
        }
    ]
}